export default __webpack_public_path__ + "static/media/receipt.desktop.35a61ba8.svg";